import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/voucher/user-vouchers?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/voucher/user-vouchers/${id}`, { params });
}

export async function create(body) {
  return request(`/voucher/user-vouchers`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/voucher/user-vouchers/${id}`, {
    method: 'POST',
    body,
  });
}